//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ffapplydept',
  props:{
    value:{
      type:String,
      default:"",
      required : true
    },
    moduid:{
      type:String,
      default:"",
      required : true
    },
    flowsysid:{
      type:String,
      default:'FLOW'
    },
    placeholder:{
      type:String,
      default:''
    },
  },
  data() {
    return {
      list : [] ,//下拉选项
      isShowFlag : true,
    };
  },
  async created() {
    //获取下拉选项
    await this.initSelect();
    this.$emit("getlist",this.readonly)
  },
  watch:{
    moduid:{
      immediate: true,
      handler () {

        if(this.moduid!=""){
          let url = "modu/checkRightlevel";
          let params = {
            pub_moduid:this.moduid,
            flowsysid:this.flowsysid
          };
          this.axios.post(url, params).then(({ data }) => {
            if(data.code=="1" && data.data!="2"){
              this.isShowFlag=false;
            }else{
              this.isShowFlag=true;
            }
          }).catch((error)=>{
            this.isShowFlag=false;
          })
        }else{
          //无权限控制
          this.isShowFlag=false;
        }
      }
    }
  },
  methods:{
        initSelect : async function(){

          let params = {
            flowsysid:this.flowsysid
          } 
          let urlArray = "userController/initUserDeptSelect";
          await this.axios.post(urlArray, params).then(({ data }) => {
            if (data.code == "1") {
               console.log("ffapplydept.initSelect : 11111111111111");
               console.log(data);
              this.list = data.data;
            } else {
              console.log("ffapplydept.initSelect : " + data.msg);
            }
          });
        }
  },
  computed: {
    readonly: function () {
            if(this.list == undefined || this.list.length <= 1){
              //返回true,设为只读
              if(this.list.length == 1){
                  this.$emit('input',this.list[0].deptid);
              }
              
              return true;
            }else{
              this.$emit('input',"");
              return false;
            }
        },
    currentdata:{
          get:function(){
            return this.value;
          },
          set:function(val){
            this.$emit('input',val)
          }
        } 
 }
  
}




// WEBPACK FOOTER //
// ./src/pccomponents/ffapplydept.vue